import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '@src/routers/constants';
import { ApiConfigurationRule } from './types';
import {
  getIntelligentCollectionConfigurations,
  postIntelligentCollectionConfiguration,
  putIntelligentCollectionConfiguration,
  deleteIntelligentCollectionConfiguration,
  reorderIntelligentCollectionConfigurations,
} from './api';

export const INTELLIGENT_COLLECTION_QUERY_KEY = 'getIntelligentCollectionConfigurations';

export const useGetIntelligentCollectionConfigurations = () => {
  return useQuery(
    [INTELLIGENT_COLLECTION_QUERY_KEY],
    async () => {
      const res = await getIntelligentCollectionConfigurations();
      return res?.data?.data || [];
    }
  );
};

export const usePostIntelligentCollectionConfiguration = () => {
  return useMutation(async (payload: Omit<ApiConfigurationRule, 'id'>) => {
    const res = await postIntelligentCollectionConfiguration(payload);
    queryClient.invalidateQueries([INTELLIGENT_COLLECTION_QUERY_KEY]);
    return res?.data?.data || res?.data;
  });
};

export const usePutIntelligentCollectionConfiguration = () => {
  return useMutation(async (payload: ApiConfigurationRule) => {
    const res = await putIntelligentCollectionConfiguration(payload);
    queryClient.invalidateQueries([INTELLIGENT_COLLECTION_QUERY_KEY]);
    return res?.data?.data || res?.data;
  });
};

export const useDeleteIntelligentCollectionConfiguration = () => {
  return useMutation(async (ruleId: string) => {
    const res = await deleteIntelligentCollectionConfiguration(ruleId);
    queryClient.invalidateQueries([INTELLIGENT_COLLECTION_QUERY_KEY]);
    return res?.data?.data || res?.data;
  });
};

export const useReorderIntelligentCollectionConfigurations = () => {
  return useMutation(async ({ ruleType, orderedIds }: { ruleType: string; orderedIds: string[] }) => {
    const res = await reorderIntelligentCollectionConfigurations(ruleType, orderedIds);
    queryClient.invalidateQueries([INTELLIGENT_COLLECTION_QUERY_KEY]);
    return res?.data?.data || res?.data;
  });
};